import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';

@Component({
  selector: 'cv-milestone-results-renderer',
  templateUrl: './milestone-results-renderer.component.html',
  styleUrls: ['./milestone-results-renderer.component.scss']
})
export class MilestoneResultsRendererComponent implements AgRendererComponent {

  params!: ICellRendererParams;
  results: any;

  gs = null;
  milestoneThemes = [];
  themeSelected: any;
  participant: any;

  constructor(
    private gamesService: GamesService,
    private metricFormatPipe: GenericMetricFormatterPipe
  ) { 
    this.gs = this.gamesService.data;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;

    if(this.params != null){
      this.results = this.params.value;
      this.participant = params['participant'];
    }
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;

    if(this.params != null){
      this.results = this.params.value;
      this.participant = params['participant'];
    }

    return true;
  }

  getThemeBackground () {
    if (this.gs.selectedGame[0] == null) return "";
    this.milestoneThemes = this.gamesService.getGameDefinitions().filter((gt) => { return gt.GameType == 5 })[0].Themes;
    this.themeSelected = this.milestoneThemes[this.gs.selectedGame[0].MilestoneDetails.MilestoneThemeSelected.themeID - 1];
    return { 'background-image': 'url(' + this.themeSelected.themePath + "background.svg" + ')' }
  }

  showMilestone (index: number): boolean {
    if (this.gs.selectedGame[0] == null) return;

    switch (index) {
      case 0: return true;
      case 1: return (this.gs.selectedGame[0].MilestoneDetails.MilestoneQty > 3) ? true : false;
      case 2: return (this.gs.selectedGame[0].MilestoneDetails.MilestoneQty > 2) ? true : false;
      case 3: return (this.gs.selectedGame[0].MilestoneDetails.MilestoneQty == 5) ? true : false;
      case 4: return true;
    }
  }

  getMilestoneImage (index: number) {
    if (this.gs.selectedGame[0] == null) 
      return { 'background-image': 'none' }

    this.milestoneThemes = this.gamesService.getGameDefinitions().filter((gt) => { return gt.GameType == 5 })[0].Themes;
    this.themeSelected = this.milestoneThemes[this.gs.selectedGame[0].MilestoneDetails.MilestoneThemeSelected.themeID - 1];

    var showMilestone = false;
    switch (this.gs.selectedGame[0].MilestoneDetails.MilestoneQty) {
      case 2:
        // Show Milestone 0,4
        if (index == 0) {
          showMilestone = this.isWinnerMilestone(this.gs.selectedGame[0], 0, this.params.data.MetricData); // MilestoneReward Index
        } else if (index == 4) {
          showMilestone = this.isWinnerMilestone(this.gs.selectedGame[0], 1, this.params.data.MetricData); // MilestoneReward Index
        }
        break;
      case 3:
        // Show Milestone 0,2,4
        if (index == 0) {
          showMilestone = this.isWinnerMilestone(this.gs.selectedGame[0], 0, this.params.data.MetricData); // MilestoneReward Index
        } else if (index == 2) {
          showMilestone = this.isWinnerMilestone(this.gs.selectedGame[0], 1, this.params.data.MetricData); // MilestoneReward Index
        } else if (index == 4) {
          showMilestone = this.isWinnerMilestone(this.gs.selectedGame[0], 2, this.params.data.MetricData); // MilestoneReward Index
        }
          break;
      case 4:
        // Show Milestone 0,1,2,4
        if (index == 0) {
          showMilestone = this.isWinnerMilestone(this.gs.selectedGame[0], 0, this.params.data.MetricData); // MilestoneReward Index
        } else if (index == 1) {
          showMilestone = this.isWinnerMilestone(this.gs.selectedGame[0], 1, this.params.data.MetricData); // MilestoneReward Index
        } else if (index == 2) {
          showMilestone = this.isWinnerMilestone(this.gs.selectedGame[0], 2, this.params.data.MetricData); // MilestoneReward Index
        } else if (index == 4) {
          showMilestone = this.isWinnerMilestone(this.gs.selectedGame[0], 3, this.params.data.MetricData); // MilestoneReward Index
        }
        break;
      case 5:
        // no matter Index show all milestones
        showMilestone = this.isWinnerMilestone(this.gs.selectedGame[0], index, this.params.data.MetricData);
        break;
    }
    return showMilestone;
  }
  
  isWinnerMilestone(gamedata: any, index: number, gameranking: any): boolean {
    if (gameranking == undefined || gameranking == null || gameranking.MyRankingObj == undefined || gameranking.MyRankingObj == null) 
      return false;
    
    if (gameranking.MyRankingObj.MetricGroupInfos && gameranking.MyRankingObj.MetricGroupInfos.length == 0)
      return false;

    //Game has Qualifier
    var isQualifiedFlag = null;

    if (gamedata.Qualifier != null) {
      isQualifiedFlag = this.isQualified(gamedata, gameranking.MyRankingObj.MetricGroupInfos[1].MyMetricValue);
    }

    //Prepare variables for comparing process 
    var metricValue = gameranking.MyRankingObj.MetricGroupInfos[0].MyMetricValue;
    var minValue = gamedata.MilestoneRewards[index].Target.Val1;
    var maxValue = gamedata.MilestoneRewards[index].Target.Val2;
    var isWinner = false;

    if (gamedata.SelectedMetrics[0].direction == "1"){ // Up Metrics    
      if (gamedata.MilestoneRewards[index].ComparisonType == 1) { //Greater than
        isWinner = (metricValue >= minValue) ? true : false;
      }
      else {
        isWinner = (metricValue >= maxValue || (metricValue >= minValue && metricValue <= maxValue)) ? true : false;
      }
    } else {  // Down Metrics    
      if (gamedata.MilestoneRewards[index].ComparisonType == 2) { //Less than
        isWinner = (metricValue <= minValue) ? true : false;
      }
      else {
        isWinner = (metricValue <= maxValue || (metricValue <= maxValue && metricValue >= minValue)) ? true : false;
      }
    }

    //Game has Qualifier
    if (gamedata.Qualifier != null && isQualifiedFlag && isWinner) {
      return true;
    }

    // Game has no Qualifier
    else if (gamedata.Qualifier == null && isQualifiedFlag == null && isWinner) {
      return true;
    }

    return false;
  }
  
  isQualified(game: any, myValue: number): boolean {
    var isQualified = false;
    
    if (game == undefined || game == null || game.Qualifier == null) return false;

    switch (game.QualifierLevels.comparerType) {
      case 1: // Greater than
        if (myValue > game.QualifierLevels.leftNumber)
          isQualified = true;
        break;
      case 2: // Less than
        if (myValue < game.QualifierLevels.leftNumber)
          isQualified = true;
        break;
      case 3: // Between
        if (myValue >= game.QualifierLevels.leftNumber && myValue <= game.QualifierLevels.rightNumber)
          isQualified = true;
        break;
      default:
        return;
    }

    return isQualified;
  }

  getFormattedMetric(value: number, format: string): string{
    return this.metricFormatPipe.transform(value, format);
  }

  getLocalizedText(key: string, defaultText: string): string{
    return this.gamesService.getLocalizedMessage(key, defaultText);
  }
}